var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAbPageIcon03(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.54,
    d: "M27.5195 10.3895C27.9976 9.71194 29.0024 9.71194 29.4805 10.3895L50.9807 40.8581C51.5416 41.653 50.9731 42.75 50.0002 42.75H6.99977C6.02687 42.75 5.45837 41.653 6.0193 40.8581L27.5195 10.3895Z",
    fill: "#33CCCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 52.25H52.25",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1562 9.5V52.25H33.8438V9.5C33.8438 6.8875 32.775 4.75 29.5687 4.75H27.4313C24.225 4.75 23.1562 6.8875 23.1562 9.5Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.125 23.75V52.25H16.625V23.75C16.625 21.1375 15.675 19 12.825 19H10.925C8.075 19 7.125 21.1375 7.125 23.75Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.375 35.625V52.25H49.875V35.625C49.875 33.0125 48.925 30.875 46.075 30.875H44.175C41.325 30.875 40.375 33.0125 40.375 35.625Z",
    stroke: "#0B1957",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbPageIcon03);
export default __webpack_public_path__ + "static/media/ab-page-icon03.ae5b761a18b7bfbb8d8c4439049cbdff.svg";
export { ForwardRef as ReactComponent };